<template>
  <div class="pageDesignerRight-table-main">
<!--    <div class="right-title">-->
<!--      <div class="title-left">组件设置 - 表单组件</div>-->
<!--    </div>-->
    <div class="right-content">
      <el-form size="small" label-width="90px" label-suffix="：">
        <el-form-item  label="字段名">
          <el-input v-model="activeData.vModel" placeholder="字段名" />
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="activeData.itemLabel" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item  label="占位提示">
          <el-input v-model="activeData.placeholder" placeholder="请输入占位提示" />
        </el-form-item>
        <el-form-item label="表单栅格">
          <el-slider v-model="activeData.span" :max="24" :min="1" :marks="{12:''}" @change="spanChange" />
        </el-form-item>
        <el-form-item label="标签宽度">
          <el-input v-model.number="activeData.labelWidth" type="number" placeholder="请输入标签宽度" />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "colForm",
  props: ['activeData', 'pageId', 'pageTemp'],
  data(){
    return {

    }
  },
  created() {

  },
  methods:{
    //修改表单栅格
    spanChange(val) {
      this.pageTemp.span = val
    },
  }
}
</script>

<style scoped>
.pageDesignerRight-table-column .el-form-item__label{padding: 0px !important;}
</style>



// WEBPACK FOOTER //
// src/components/PageDesigner/item/colForm.vue